/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Setpointtemperatureoninoccupation3Inputs */



/**
* | output |
* | --- |
* | "Setpoint temperature during inoccupation" |
*
* @param {Br_History_Key_Setpointtemperatureoninoccupation3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_setpointtemperatureoninoccupation3 = /** @type {((inputs?: Br_History_Key_Setpointtemperatureoninoccupation3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Setpointtemperatureoninoccupation3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Setpoint temperature during inoccupation")
	return /** @type {LocalizedString} */ ("Température de consigne en inoccupation")
});
export { br_history_key_setpointtemperatureoninoccupation3 as "br_history_key_setpointTemperatureOnInoccupation" }